import { createFileRoute } from '@tanstack/react-router'
import { creatorsQueryKey } from '@/modules/creators/hooks'
import { creatorRepository } from '@/data/adapters/api/creators.api'
import { useAppStore } from '@/stores/app.store'

export const Route = createFileRoute('/$orgSlug/$clientSlug/creators')({
  loader: ({ context: { queryClient, client } }) => {
    const range = useAppStore.getState().dateRange
    return queryClient.ensureQueryData({
      queryKey: creatorsQueryKey(client.id, range),
      queryFn: () => creatorRepository.getCreators(client.id, range),
    })
  },
})
